import { scannerUiByLanguage } from "./scannerUi";
import cmsSiteContent from "../cmsSiteContent.cjs";
import { getCmsSnapshot } from "../cmsSnapshot.js";
import { SCAN_DEVICE_ILLUSTRATIONS, getScanTroubleshootingIllustrations } from "./illustrations";
import af from "./locales/af.json";
import ar from "./locales/ar.json";
import bn from "./locales/bn.json";
import de from "./locales/de.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import ha from "./locales/ha.json";
import hi from "./locales/hi.json";
import id from "./locales/id.json";
import it from "./locales/it.json";
import km from "./locales/km.json";
import ko from "./locales/ko.json";
import lo from "./locales/lo.json";
import ms from "./locales/ms.json";
import mm from "./locales/mm.json";
import pt from "./locales/pt.json";
import ru from "./locales/ru.json";
import sw from "./locales/sw.json";
import tl from "./locales/tl.json";
import tr from "./locales/tr.json";
import ur from "./locales/ur.json";
import zh from "./locales/zh.json";
import zh_tw from "./locales/zh-tw.json";
import en from "./en";
import ja from "./ja";
import th from "./th";

const vi = {
  seo: {
    title: "Quét QR Code Online Từ Hình Ảnh Miễn Phí | QRCode GEN",
    description:
      "Kéo thả hoặc tải ảnh lên để quét QR Code online ngay trên trình duyệt. Xem nội dung mã, sao chép kết quả và tham khảo cách quét trên iPhone, Android, LINE.",
    keywords:
      "quét qr code online, scan qr code từ ảnh, đọc mã qr từ hình ảnh, quét mã qr trên máy tính, quét qr code iphone, quét qr code android"
  },
  ui: {
    home: "Trang chủ",
    highlights: "Điểm nổi bật",
    idleTitle: "Kết quả sẽ hiển thị tại đây",
    idleDescription: "Chọn một ảnh để bắt đầu đọc nội dung QR Code.",
    errorTitle: "Chưa đọc được mã",
    backToScanner: "Quay lại công cụ quét ↑",
    faqEyebrow: "FAQ"
  },
  breadcrumb: "Quét QR Code online",
  eyebrow: "Công cụ đọc QR Code từ hình ảnh",
  title: "Quét QR Code online từ hình ảnh",
  intro:
    "Quét QR Code từ ảnh hoặc camera. Kết quả hiện trong cửa sổ bật lên. Bạn có thể sao chép nội dung hoặc bấm Mở liên kết với URL HTTP/HTTPS hợp lệ.",
  benefits: [
    "Không cần cài ứng dụng",
    "Ảnh được xử lý trên thiết bị",
    "Nội dung QR Code"
  ],
  tool: {
    title: "Tải ảnh có QR Code",
    description:
      "Dùng ảnh gốc hoặc ảnh chụp màn hình rõ nét, có đầy đủ bốn cạnh và khoảng trắng quanh mã.",
    dropTitle: "Kéo thả ảnh QR Code vào đây",
    dropActiveTitle: "Thả ảnh để bắt đầu quét",
    dropDescription: "hoặc chọn ảnh từ điện thoại hay máy tính",
    chooseFile: "Chọn ảnh",
    fileHint: "Hỗ trợ PNG, JPG, JPEG và WebP · tối đa 12 MB",
    privacy:
      "Ảnh được đọc trực tiếp trong trình duyệt và không được gửi lên máy chủ QRCode GEN.",
    processing: "Đang đọc QR Code trong ảnh…",
    resultTitle: "Nội dung QR Code",
    resultType: "Loại nội dung",
    copy: "Sao chép",
    copied: "Đã sao chép",
    openLink: "Mở liên kết",
    scanAnother: "Quét ảnh khác",
    previewAlt: "Ảnh QR Code đã chọn",
    idleTabTitle: "Đang đọc QR Code…",
    idleTabMessage: "Đang đọc nội dung QR Code…",
    noResult:
      "Không tìm thấy QR Code trong ảnh. Hãy dùng ảnh rõ hơn, không bị cắt cạnh và thử lại.",
    invalidType: "File đã chọn không phải ảnh PNG, JPG, JPEG hoặc WebP.",
    tooLarge: "Ảnh vượt quá 12 MB. Hãy giảm dung lượng rồi thử lại.",
    imageError: "Không thể mở ảnh này. Hãy lưu lại dưới dạng PNG hoặc JPG rồi thử lại.",
    copyError: "Không thể sao chép tự động. Hãy chọn và sao chép nội dung bên dưới.",
    safety:
      "Hãy kiểm tra tên miền trước khi nhập mật khẩu, OTP hoặc thông tin thanh toán vì công cụ không xác minh độ an toàn của website đích.",
    types: {
      url: "Liên kết website",
      wifi: "Thông tin Wi-Fi",
      email: "Email",
      phone: "Số điện thoại",
      sms: "Tin nhắn SMS",
      vcard: "Thông tin liên hệ vCard",
      payment: "Dữ liệu thanh toán",
      text: "Văn bản"
    }
  },
  onlineGuide: {
    eyebrow: "Quét trực tiếp trên QRCode GEN",
    title: "Cách quét QR Code online từ một file ảnh",
    intro:
      "Cách này phù hợp khi QR Code nằm trong ảnh chụp màn hình, email, tài liệu hoặc đang hiển thị trên chính thiết bị bạn dùng.",
    visual: {
      alt: "Minh hoạ ba bước tải ảnh QR Code, đọc mã trên trình duyệt và xem kết quả",
      source: "Ảnh QR Code",
      process: "Đọc trên trình duyệt",
      result: "Xem kết quả"
    },
    steps: [
      {
        number: "01",
        title: "Chuẩn bị ảnh rõ và đầy đủ",
        description:
          "Lưu ảnh hoặc chụp màn hình sao cho thấy trọn QR Code. Không cắt mất ba ô định vị lớn ở các góc và khoảng trắng quanh mã."
      },
      {
        number: "02",
        title: "Kéo thả hoặc chọn file",
        description:
          "Đưa ảnh vào vùng tải lên ở đầu trang. Công cụ sẽ đọc ảnh ngay trên trình duyệt, không cần camera và không cần cài thêm ứng dụng."
      },
      {
        number: "03",
        title: "Kiểm tra nội dung vừa đọc",
        description:
          "Kết quả hiện trong cửa sổ bật lên. Bạn có thể sao chép nội dung hoặc bấm Mở liên kết với URL HTTP/HTTPS hợp lệ."
      },
      {
        number: "04",
        title: "Sao chép hoặc mở kết quả",
        description:
          "Sao chép nội dung để dùng ở nơi khác hoặc bấm Mở liên kết sau khi kiểm tra địa chỉ. Đóng cửa sổ kết quả để quay lại công cụ và quét tiếp."
      }
    ]
  },
  deviceGuides: [
    {
      id: "scan-qr-code-iphone",
      icon: "mobile",
      eyebrow: "iOS · iPhone và iPad",
      title: "Cách quét QR Code trên iPhone",
      description:
        "iPhone và iPad có thể nhận QR Code bằng ứng dụng Camera hoặc Code Scanner trong Trung tâm điều khiển.",
      steps: [
        "Mở Camera từ Màn hình chính, Màn hình khoá hoặc Trung tâm điều khiển.",
        "Giữ thiết bị để toàn bộ QR Code nằm trong khung hình; không cần bấm chụp ảnh.",
        "Chờ thông báo hoặc liên kết xuất hiện, đọc địa chỉ rồi chạm để mở.",
        "Nếu cần thêm Code Scanner, mở Trung tâm điều khiển, giữ nền, chọn Thêm điều khiển rồi thêm Quét mã."
      ],
      note:
        "Nếu QR Code nằm trong ảnh trên chính iPhone, bạn có thể tải ảnh đó lên công cụ ở đầu trang thay vì dùng thêm một thiết bị.",
      visual: {
        type: "iphone",
        alt: "Minh hoạ iPhone dùng Camera nhận diện QR Code và hiển thị liên kết",
        app: "Camera",
        status: "Đã nhận diện liên kết",
        caption: "Đưa toàn bộ QR Code vào khung Camera và chạm vào thông báo xuất hiện."
      }
    },
    {
      id: "scan-qr-code-android",
      icon: "globe",
      eyebrow: "Android",
      title: "Cách quét QR Code trên điện thoại Android",
      description:
        "Khả năng quét trực tiếp phụ thuộc hãng điện thoại, ứng dụng Camera và phiên bản Android.",
      steps: [
        "Mở Camera ở chế độ Ảnh và hướng vào QR Code. Nếu máy hỗ trợ, một banner sẽ xuất hiện để mở nội dung.",
        "Nếu Camera không nhận, tìm chế độ QR hoặc mở Google Lens từ Camera, Google Photos hay ứng dụng Google.",
        "Trên Samsung Galaxy, có thể dùng Camera hoặc nút Scan QR code trong bảng Cài đặt nhanh; một số máy cần bật Scan QR codes trong cài đặt Camera.",
        "Với QR Code nằm trong ảnh đã lưu, mở ảnh bằng Gallery hoặc Google Photos rồi dùng Lens, hoặc tải ảnh lên công cụ trên trang này."
      ],
      note:
        "Camera from Google chỉ hỗ trợ quét QR trên một số thiết bị. Tên nút và vị trí chức năng có thể khác theo nhà sản xuất.",
      visual: {
        type: "android",
        alt: "Minh hoạ điện thoại Android dùng Google Lens để quét QR Code",
        app: "Google Lens",
        status: "Chạm để mở nội dung",
        caption: "Nếu Camera không nhận mã, hãy mở Lens hoặc tính năng quét QR có sẵn trên máy."
      }
    },
    {
      id: "scan-qr-code-social-apps",
      icon: "message",
      eyebrow: "Ứng dụng nhắn tin và mạng xã hội",
      title: "Quét QR Code bằng LINE, Zalo và các ứng dụng khác",
      description:
        "Một số ứng dụng có trình quét riêng, nhưng phạm vi nội dung được hỗ trợ không giống nhau.",
      steps: [
        "LINE có nút quét cạnh thanh tìm kiếm và có thể đọc mã LINE, URL, văn bản cùng một số loại mã khác.",
        "Trong trình quét LINE, có thể chọn biểu tượng ảnh để đọc QR Code từ hình đã lưu trên điện thoại.",
        "Zalo có trình quét phục vụ mã hồ sơ, kết bạn, đăng nhập và một số liên kết; kết quả có thể phụ thuộc loại mã.",
        "Các công cụ QR trong Facebook, Instagram, TikTok hoặc ứng dụng ngân hàng thường ưu tiên mã thuộc hệ sinh thái của chính ứng dụng. Không nên coi chúng là trình đọc QR đa dụng."
      ],
      note:
        "Với QR thanh toán, hãy dùng ứng dụng ngân hàng hoặc ví tương thích để kiểm tra người nhận và số tiền trước khi xác nhận.",
      visual: {
        type: "social",
        alt: "Minh hoạ trình quét QR Code trong LINE, Zalo và ứng dụng ngân hàng",
        app: "Trình quét trong ứng dụng",
        status: "Chọn đúng ứng dụng theo loại mã",
        labels: ["LINE", "Zalo", "Ngân hàng"],
        caption: "Trình quét trong từng ứng dụng có thể chỉ hỗ trợ một số loại QR Code nhất định."
      }
    },
    {
      id: "other-qr-code-scanners",
      icon: "qrcode",
      eyebrow: "Các phương án khác",
      title: "Khi Camera không quét được QR Code",
      description:
        "Không cần cài ngay một ứng dụng lạ. Hãy thử những cách ít rủi ro hơn trước.",
      steps: [
        "Hiển thị QR Code trên một màn hình và dùng điện thoại thứ hai để quét bằng Camera.",
        "Chụp màn hình hoặc lưu ảnh, sau đó tải lên QRCode GEN bằng máy tính hay điện thoại.",
        "Dùng Google Lens hoặc công cụ nhận diện có sẵn trong thư viện ảnh của thiết bị.",
        "Nếu phải cài ứng dụng quét riêng, chỉ tải từ cửa hàng chính thức, xem đánh giá và tránh ứng dụng yêu cầu quyền không liên quan."
      ],
      note:
        "Máy quét mã vạch tại quầy phải hỗ trợ mã hai chiều 2D. Thiết bị chỉ đọc mã vạch 1D sẽ không đọc được QR Code.",
      visual: {
        type: "alternatives",
        alt: "Minh hoạ tải ảnh QR Code từ máy tính để đọc nội dung trực tuyến",
        app: "Ảnh đã lưu",
        status: "Nội dung QR Code",
        caption: "Lưu ảnh hoặc chụp màn hình rồi tải lên công cụ ở đầu trang để đọc mã."
      }
    }
  ],
  troubleshooting: {
    eyebrow: "Ảnh không đọc được?",
    title: "Các lỗi thường gặp khi quét QR Code từ hình ảnh",
    items: [
      {
        title: "Ảnh bị cắt mất cạnh hoặc khoảng trắng",
        description:
          "Dùng lại ảnh đầy đủ. Ba ô vuông định vị lớn và vùng nền sáng quanh mã cần còn nguyên."
      },
      {
        title: "QR Code quá nhỏ trong một ảnh lớn",
        description:
          "Cắt bớt phần nền thừa nhưng không cắt vào mã, sau đó lưu ảnh ở chất lượng cao và thử lại."
      },
      {
        title: "Ảnh mờ, nén mạnh hoặc bị phản chiếu",
        description:
          "Dùng file gốc, ảnh chụp gần hơn hoặc tăng độ sáng màn hình nếu đang chụp QR Code từ thiết bị khác."
      },
      {
        title: "QR Code có mật độ quá cao",
        description:
          "vCard nhiều trường, văn bản dài và URL có nhiều tham số tạo ra mã dày. Người tạo mã nên giảm dữ liệu, dùng short link hoặc QR Code động."
      },
      {
        title: "Ảnh có nhiều QR Code",
        description:
          "Cắt riêng mã cần đọc. Công cụ hiện trả về QR Code đầu tiên nhận diện được trong ảnh."
      },
      {
        title: "Đã đọc được nhưng liên kết không mở",
        description:
          "Hình QR vẫn hoạt động; lỗi có thể nằm ở mạng, quyền truy cập file, website đã đổi địa chỉ hoặc nội dung đích bị xoá."
      }
    ]
  },
  safety: {
    eyebrow: "Kiểm tra trước khi mở",
    title: "Quét được QR Code không có nghĩa nội dung luôn an toàn",
    description:
      "Hãy kiểm tra tên miền trước khi nhập mật khẩu, OTP hoặc thông tin thanh toán vì công cụ không xác minh độ an toàn của website đích.",
    checks: [
      "Đọc kỹ tên miền, đặc biệt các ký tự gần giống tên thương hiệu",
      "Không nhập mật khẩu, OTP hoặc thông tin thẻ nếu chưa xác minh website",
      "Không cài ứng dụng từ file tải xuống ngoài cửa hàng chính thức",
      "Với thanh toán, kiểm tra người nhận, số tiền và nội dung trong ứng dụng ngân hàng"
    ]
  },
  faq: {
    eyebrow: "FAQ",
    title: "Câu hỏi thường gặp về quét QR Code online",
    items: [
      {
        q: "Ảnh QR Code có được tải lên máy chủ không?",
        a: "Không. Công cụ đọc pixel của ảnh ngay trong trình duyệt trên thiết bị. QRCode GEN không cần gửi file ảnh lên máy chủ để giải mã."
      },
      {
        q: "Có thể quét QR Code từ ảnh chụp màn hình không?",
        a: "Có, nếu ảnh đủ rõ và chứa đầy đủ mã. Nếu ảnh chụp cả màn hình khiến QR Code quá nhỏ, hãy cắt gần mã nhưng giữ nguyên các cạnh và khoảng trắng xung quanh."
      },
      {
        q: "Công cụ hỗ trợ định dạng ảnh nào?",
        a: "Trang hỗ trợ PNG, JPG, JPEG và WebP với dung lượng tối đa 12 MB. HEIC chưa được hỗ trợ trực tiếp; hãy chuyển ảnh sang JPG hoặc PNG."
      },
      {
        q: "Vì sao ảnh nhìn rõ nhưng vẫn không đọc được?",
        a: "Mã có thể bị cắt vùng trắng, biến dạng, tương phản thấp hoặc chứa quá nhiều dữ liệu so với kích thước. Hãy thử file gốc, cắt bớt nền thừa hoặc dùng ảnh có độ phân giải cao hơn."
      },
      {
        q: "Có thể quét QR thanh toán bằng công cụ này không?",
        a: "Công cụ có thể hiển thị chuỗi dữ liệu nếu đọc được mã, nhưng không xác minh tài khoản nhận tiền và không thực hiện thanh toán. Hãy quét lại bằng ứng dụng ngân hàng tương thích và kiểm tra người nhận, số tiền trước khi xác nhận."
      },
      {
        q: "Tại sao đã đọc được URL nhưng trang đích không mở?",
        a: "Việc đọc QR Code và truy cập nội dung là hai bước khác nhau. Hãy kiểm tra kết nối mạng, chính tả URL, quyền chia sẻ file và xem nội dung đích còn tồn tại hay không."
      }
    ]
  },
  relatedTitle: "Nội dung liên quan",
  relatedLinks: [
    { href: "/help", label: "Xử lý lỗi khi Camera không nhận QR Code" },
    { href: "/products/short-link", label: "Rút gọn URL để QR Code dễ quét hơn" },
    { href: "/products/custom-qr-code", label: "Tùy chỉnh QR Code vẫn giữ khả năng đọc" },
    { href: "/what-is-qr-code", label: "QR Code hoạt động như thế nào?" }
  ],
  cta: {
    title: "Cần tạo một QR Code mới?",
    description:
      "Chọn loại nội dung, kiểm tra dữ liệu rồi tạo và tải mã ngay trên QRCode GEN.",
    href: "/",
    label: "Tạo QR Code miễn phí"
  }
};

export const SCAN_QR_PAGE_PATH = "/scan-qr-code";
// Public locale keys match the SEO language registry; lookup keys are normalized.
export const SCAN_QR_PAGE_SUPPORTED_LANGUAGES = Object.freeze([
  "vi", "en", "th", "ja", "af", "ar", "bn", "de", "es", "fr", "ha", "hi",
  "id", "it", "km", "ko", "lo", "ms", "mm", "pt", "ru", "sw", "tl", "tr",
  "ur", "zh", "zh-TW"
]);

const contentByLanguage = Object.freeze(Object.fromEntries(Object.entries({
  vi, en, th, ja, af, ar, bn, de, es, fr, ha, hi, id, it, km, ko, lo, ms, mm,
  pt, ru, sw, tl, tr, ur, zh, "zh-tw": zh_tw
}).map(([language, page]) => [language, { ...page, scannerUi: scannerUiByLanguage[language] }])));

export function isScanQrPageLanguageSupported(language) {
  return Boolean(getScanQrPageContent(language));
}

// { cms: false } → nội dung mặc định trong code (endpoint defaults của form admin)
export function getScanQrPageContent(language, { cms = true } = {}) {
  const normalizedLanguage = String(language || "").trim().toLowerCase();
  const base = contentByLanguage[normalizedLanguage] || null;
  if (!base || !cms) return base;
  // Override Content Hub (pageKey "scan"), snapshot lúc build — mảng cố định theo registry
  return cmsSiteContent.applyCmsPageData(base, getCmsSnapshot(), normalizedLanguage, "scan");
}

export function getScanQrPageServerSections(language) {
  const page = getScanQrPageContent(language);
  if (!page) return [];

  return [
    {
      heading: page.onlineGuide.title,
      paragraphs: [page.onlineGuide.intro],
      bullets: page.onlineGuide.steps.map(
        (step) => `${step.title}: ${step.description}`
      )
    },
    ...page.deviceGuides.map((guide) => ({
      heading: guide.title,
      illustrations: SCAN_DEVICE_ILLUSTRATIONS[guide.visual.type]
        ? [{...SCAN_DEVICE_ILLUSTRATIONS[guide.visual.type],alt:guide.visual.alt}]
        : [],
      paragraphs: [guide.description, guide.note],
      bullets: guide.steps
    })),
    {
      heading: page.troubleshooting.title,
      illustrations: page.troubleshooting.items.map((item,index) => ({
        ...getScanTroubleshootingIllustrations(language)[index],
        alt:item.title, title:item.title, description:item.description
      }))
    },
    {
      heading: page.safety.title,
      paragraphs: [page.safety.description],
      bullets: page.safety.checks
    },
    {
      heading: page.faq.title,
      bullets: page.faq.items.map((item) => `${item.q} ${item.a}`)
    }
  ];
}
